import React, { useState } from 'react';
import { Input, Modal } from 'antd';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Button, Col, MasterDetailForm, Widget, Row, FormDatePicker, FormSubmitButton } from '@digital/ui';
import * as Yup from 'yup';
import { enviarCartaConviteFornecedor, getCartaConviteCorpoEmail } from '@app/api/sas/ordemCompra';
import { ordemCompraIdState, reloadVendorListState, dataLimiteEtapaState } from '../atoms';
import { Visibility } from '@app/components';

const substituirObjeto = (template: string, objeto: string) =>
  template.replace(/(da (?:OC \S+ -|CONSULTIVA -) )[^\n]*/, function(_, prefix) { return prefix + objeto; });

interface Props {
}

const ModalEnvioCartaConvite = ({ }: Props) => {
  const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
  const ordemCompraId = useRecoilValue(ordemCompraIdState);
  const dataLimiteEtapa = useRecoilValue(dataLimiteEtapaState);

  const [exibirModal, setExibirModal] = useState(false);
  const [corpoEmailInicial, setCorpoEmailInicial] = useState('');
  const [objetoAtual, setObjetoAtual] = useState('');

  const abrirModal = () => {
    getCartaConviteCorpoEmail(ordemCompraId).then((data: any) => {
      setCorpoEmailInicial(data && data.corpoEmail);
      setObjetoAtual(data && data.objeto);
      setExibirModal(true);
    });
  };

  const onDiscordar = () => {
    setExibirModal(false);
  };

  const onConcordar = (values: any) => {
    if (!objetoAtual.trim()) return;
    Modal.confirm({
      title: 'Confirmação Envio de Email',
      content: 'Você deseja enviar este e-mail?',
      cancelText: 'Não',
      onCancel: () => {
        enviar(values);
      },
      okText: 'Sim',
      onOk: () => {
        enviar({ ...values, envioEmail: true });
      },
    });
  };

  const enviar = (values: any) => {
    enviarCartaConviteFornecedor({
      id: ordemCompraId,
      envioEmail: values.envioEmail || false,
      corpoEmailCustomizado: substituirObjeto(corpoEmailInicial, objetoAtual),
      dataCartaConvite: values.dataCartaConvite,
      objetoDaDemanda: objetoAtual,
    })
      .then((data: any) => {
        if (data) {
          setReloadVendorList(!reloadVendorList);
        }
      })
      .finally(() => {
        setExibirModal(false);
      });
  };

  return (
    <>
      <Button
        type="primary"
        style={{ float: 'right', marginRight: '5px' }}
        onClick={abrirModal}>
        Enviar Carta Convite
      </Button>
      <Visibility visible={exibirModal}>
        <Modal
          title="Envio da Carta Convite"
          width="780px"
          visible={exibirModal}
          onCancel={() => setExibirModal(false)}
          footer={null}>
          <MasterDetailForm
            key={corpoEmailInicial}
            initialValues={{
              dataCartaConvite: undefined,
            }}
            validationSchema={Yup.object().shape({
              dataCartaConvite: Yup.string().nullable().required('Campo obrigatório'),
            })}
            actions={[
              <Button key="cancelarBtn" type="link" onClick={onDiscordar}>
                Cancelar
              </Button>,
              <FormSubmitButton key="enviarBtn" title="Enviar" noIcon type="primary" onClick={onConcordar} />,
            ]}>
            <Widget>
              <Row>
                <FormDatePicker
                  label="Data Limite de Resposta"
                  name="dataCartaConvite"
                  format="DD/MM/YYYY"
                  span={4}
                  disabledDate={function(current) {
                    if (!dataLimiteEtapa) return false;
                    var limite = new Date(dataLimiteEtapa);
                    limite.setHours(23, 59, 59, 999);
                    return current && current.toDate() > limite;
                  }}
                />
              </Row>
              <Row>
                <Col span={12}>
                  <label>Objeto da Demanda</label><br></br>
                  <Input.TextArea
                    value={objetoAtual}
                    onChange={function(e) { setObjetoAtual(e.target.value); }}
                    rows={2}
                  />
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <label>Pré-visualização do E-mail</label><br></br>
                  <Input.TextArea
                    value={substituirObjeto(corpoEmailInicial, objetoAtual)}
                    disabled
                    rows={8}
                  />
                </Col>
              </Row>
            </Widget>
          </MasterDetailForm>
        </Modal>
      </Visibility>
    </>
  );
};

export default ModalEnvioCartaConvite;
